module.exports = __webpack_public_path__ + "static/media/01C.5e38fec3.png";